import React from 'react';
import banner1 from "../../assets/images/banners/banner1.jpg";
import banner2 from "../../assets/images/banners/banner-2.jpg";
import banner3 from "../../assets/images/banners/banner-3.jpg";
import BusinessIntegrator_Branco from "../../assets/images/banners/BusinessIntegrator_Branco.png";
import plex from "../../assets/images/banners/plex.png";
import texto2 from "../../assets/images/banners/texto2.png";
import texto3 from "../../assets/images/banners/texto3.png";

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const BannerLogin = () => {
  return (
    <div className="slider-container w-100" style={{ position: 'relative' }}>
      {/* Imagem sobreposta na parte superior */}
      <img
        src={BusinessIntegrator_Branco}
        alt="BusinessIntegrator"
        style={{
          position: 'absolute',
          top: '20px',
          right: '0%',
          transform: 'translateX(-50%)',
          zIndex: 999,
          objectFit: 'cover'
        }}
      />

      {/* Overlay semitransparente por cima de todo o carousel */}
      <div className="overlay-banner-login"
        
      ></div>

      <div
        id="carouselExampleIndicators"
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ position: 'relative' }}
      >
        {/* Bolinhas de navegação (indicadores) */}
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>

        {/* Slides */}
        <div className="carousel-inner">
          <div className="carousel-item active" style={{ position: 'relative' }}>
            <img
              src={banner1}
              className="d-block w-100 banner-login"
              alt="Banner 1"
            />
            {/* Imagem do PLEX centralizada na parte inferior do primeiro slide */}
            <img
              src={plex}
              alt="Plex"
              style={{
                position: 'absolute',
                bottom: '160px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                maxWidth: '354px'
              }}
            />
          </div>
          <div className="carousel-item" style={{ position: 'relative' }}>
            <img
              src={banner2}
              className="d-block w-100 banner-login"
              alt="Banner 2"
            />
            <img
              src={texto2}
              alt="texto2"
              style={{
                position: 'absolute',
                bottom: '160px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                maxWidth: '660px'
              }}
            />
          </div>
          <div className="carousel-item" style={{ position: 'relative' }}>
            <img
              src={banner3}
              className="d-block w-100 banner-login"
              alt="Banner 3"
            />
            <img
              src={texto3}
              alt="texto3"
              style={{
                position: 'absolute',
                bottom: '160px',
                left: '50%',
                transform: 'translateX(-50%)',
                zIndex: 1000,
                maxWidth: '660px'
              }}
            />
          </div>
        </div>

        {/* Setas de navegação (anterior e próximo) */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Anterior</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="visually-hidden">Próximo</span>
        </button>
      </div>
    </div>
  );
};

export default BannerLogin;
